export default "__VITE_ASSET__b78d6795__"